// test2698
(2698 && 0);
